import React, { useState, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik, useField } from "formik";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";

import driverApi from "Services/Driver";

//Tabs
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

//Components

import BasicInformation from "./Basic";
import BankInformation from "./Bank";
import Services from "./Services";
import Vehicledocuments from "./Vehicle_documents";
import PreviewDriver from "./Preview";
import Status from "./Status";
import { apiUrl } from "../../../../Constants";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomTabPanel(props) {
  const { children, value, index, disabled = false, ...other } = props;
  const intl = useIntl();
  const t = intl.formatMessage;
   if (value !== index || disabled) {
    return (
       <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{t({ id: "driver.modal.completeSteps" })}</Typography>
        </Box>
      )}
    </div>

    )
  }
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool, 
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const DriverUpdate = (props) => {
  const { openDialog, handleClose, driverId  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const t = intl.formatMessage;
  const authUser = useSelector((state) => state?.AuthReducer?.user || {});

  console.log(authUser)
  

  //Tabs

  const [value, setValue] = useState(0);
  const [skipButton, setSkipButton] = useState(false);
  const [backButton, setBackButton] = useState(false);
  const [submitButton, setsubmitButton] = useState(true);

  // Modals

  const [previewDriverModal, setPreviewDriverModal] = useState(false);

  // Handle Tab Change

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Skip button and Back Button

  useEffect(() => {
    if (value === 0) {
      setSkipButton(false);
      setBackButton(false);
    }

    if (value === 1 || value === 2 || value === 3 || value === 4 || value === 5) {
      setSkipButton(true);
      setBackButton(true);
    }
  }, [value]);

  // Handle Back Button

  const handleBackButton = () => {
    const newValue = value - 1;
    setValue(newValue);
  };

  // Handle Next Button

  const handleSkipButton = () => {
    const newValue = value + 1;
    setValue(newValue);
  };

  // Preview Modal

  const handleOpenDriverModal = () => {
    setPreviewDriverModal(true);
  };

  const handleClosePreviewDriverModal = () => {
    setPreviewDriverModal(false);
  };

 // Tab 1 - Handle basic info

const [driverData, setDriverData] = useState([]);
  // Handle get driver details

  const handleGetDriverDetails = () => {
    dispatch(showLoader(t({ id: "driver.loading" })));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
       // console.log('driverdata:->',res?.data?.data)
        setDriverData(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || t({ id: "driver.fetchError" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    driverApi.getDriverDetailsById(driverId).then(onSuccess, onFailure);
  };

  useEffect(() => {
    if (driverId !== "") {
      handleGetDriverDetails();
    }
  }, [openDialog]);

  useEffect(() => {
    const updateFormValues = async () => {
    if (!_.isEmpty(driverData)) {
      formik.setFieldValue("firstName", driverData?.firstName);
      formik.setFieldValue("lastName", driverData?.lastName);
      formik.setFieldValue("email", driverData?.email);
      formik.setFieldValue("gender", driverData?.gender);
      formik.setFieldValue("email", driverData?.email);
      formik.setFieldValue("gender", driverData?.gender);
      formik.setFieldValue("country", driverData?.country);
      formik.setFieldValue("countryCode", driverData?.countryCode);
      formik.setFieldValue("mobile", driverData?.mobileNumber);
      formik.setFieldValue("passengerProfileImagefileformat",`${apiUrl}${driverData?.imageLocal}`);
      formik.setFieldValue("passengerProfileImage", `${apiUrl}${driverData?.imageLocal}`);
    }
  }
  updateFormValues();
  }, [driverData]);

  const handleUpdateDrivers = (formValues) => {
    dispatch(showLoader(t({ id: "driver.loading" })));
    let validatationPass = true;

    const data = {
      firstName: formValues?.firstName,
      lastName: formValues?.lastName,
      countryCode: formValues?.countryCode,
      mobileNumber: formValues?.mobile,
      email: formValues?.email,
      image: formValues?.passengerProfileImagefileformat,
      userType: "DRIVER",
      gender: formValues?.gender,
      country: formValues?.country,
   //   address: formValues?.address,
   //   bankAccountNumber: formValues?.bankAccountNumber,
    };
//console.log('data-->',data);
//return false;
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        dispatch(
          showSnackbar({
            message: t({ id: "driver.modal.update.success" }),
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        setValue(1);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || t({ id: "driver.modal.update.error" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    driverApi.updateDriver(driverId, { ...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
  initialValues: {
    firstName: "",
    lastName: "",
    email: "",
    gender: "",
    country: "",
    mobile: "",
    countryCode: "",
    passengerProfileImage:"",
    passengerProfileImagefileformat:""
  },
  enableReinitialize: true,
  onSubmit: async (values) => {
    handleUpdateDrivers(values); // Ensure this processes `values` correctly
  },
  });

 // Tab 2 - Handle background:  info

const [driverbankData, setDriverbankData] = useState([]);
  // Handle get driver details

  const handleGetDriverbankDetails = () => {
    dispatch(showLoader(t({ id: "driver.loading" })));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
       // console.log('driverdata:->',res?.data?.data)
        setDriverbankData(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || t({ id: "driver.fetchError" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    driverApi.getDriverbankDetailsById(driverId).then(onSuccess, onFailure);
  };

  useEffect(() => {
    if (driverId !== "") {
      handleGetDriverbankDetails();
    }
  }, [openDialog]);

  useEffect(() => {
    const updateFormValues = async () => {
    if (!_.isEmpty(driverbankData)) {
      formikbank.setFieldValue("bank_account_number", driverbankData?.bank_account_number);
      formikbank.setFieldValue("dob", driverbankData?.dob);
      formikbank.setFieldValue("sort_code", driverbankData?.sort_code);
      formikbank.setFieldValue("Address", driverbankData?.Address);
      formikbank.setFieldValue("postelcode", driverbankData?.postelcode);
      formikbank.setFieldValue("city", driverbankData?.city);
      formikbank.setFieldValue("state", driverbankData?.state);
      formikbank.setFieldValue("country", driverbankData?.country);
      
    }
  }
  updateFormValues();
  }, [driverbankData]);

  const handleUpdateDriversbank = (formValues) => {
    dispatch(showLoader(t({ id: "driver.loading" })));
    let validatationPass = true;

    const data = {
      bank_account_number: formValues?.bank_account_number,
      dob: formValues?.dob,
      sort_code: formValues?.sort_code,
      Address: formValues?.Address,
      postelcode: formValues?.postelcode,
      city: formValues?.city,
      state: formValues?.state,
      country: formValues?.country,
     
    };
console.log('bankdata-->',data);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: t({ id: "driver.bank.updateSuccess" }),
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        setValue(2);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || t({ id: "driver.modal.update.error" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    driverApi.updateDriverbankdetails(driverId, { ...data }).then(onSuccess, onFailure);
  };

  const formikbank = useFormik({
  initialValues: {
    bank_account_number: "",
    dob:"",
    sort_code:"",
    Address:"",
    postelcode:"",
    city:"",
    state:"",
    country:"",
   
  },
  validationSchema: yup.object({
  bank_account_number: yup.string().required(t({ id: "driver.bank.validate.accountRequired" })).nullable(),
  dob: yup.string().required(t({ id: "driver.bank.validate.dobRequired" })).nullable(),
  sort_code: yup.string().required(t({ id: "driver.bank.validate.sortCodeRequired" })).nullable(),
  Address: yup.string().required(t({ id: "driver.bank.validate.addressRequired" })).nullable(),
  postelcode: yup.string().required(t({ id: "driver.bank.validate.postalRequired" })).nullable(),
  city: yup.string().required(t({ id: "driver.bank.validate.cityRequired" })).nullable(),
  state: yup.string().required(t({ id: "driver.bank.validate.stateRequired" })).nullable(),
  country: yup.string().required(t({ id: "driver.bank.validate.countryRequired" })).nullable(),
  
  }),
  enableReinitialize: true,
  onSubmit: async (values) => {
    handleUpdateDriversbank(values); // Ensure this processes `values` correctly
  },
  }); 


  /* Tabs 4
   *  Handle Services
   */

  const [serviceCreated, setServiceCreated] = useState(false);

  const handleUpdateServices = (formValues) => {
    dispatch(showLoader(t({ id: "driver.loading" })));
      //console.log('service formValues-->',formValues);
    let data = {
      userId: driverId,
      serviceTypeId: formValues?.service,
      sub_companyName: formValues?.subcompanyname,
      serviceKind: formValues?.serviceType,
      allowedTypes: formValues?.allowedTypes,
      vehicleNumber: formValues?.vehicleNumber,
      vehicleModel: formValues?.vehicleModel,
      driverLicenseNumber: formValues?.driverLicenseNumber,
      licenseExpiryDate: formValues?.licenseExpiryDate,
      vehicleInsuranceNumber: formValues?.vehicleInsuranceNumber,
      insuranceExpiryDate: formValues?.insuranceExpiryDate,
      vehicleColour:formValues?.vehicleColour,
      loginBy: "MANUAL",
      //accountStatus:"APPROVED",
      tripStatus:"READY"
    };
//console.log('data-->',data);
//return false;
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200 || res?.status === 201) {
        dispatch(
          showSnackbar({
            message: t({ id: "driver.service.updateSuccess" }),
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
      }
      setServiceCreated(true);
      setValue(4);
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || t({ id: "driver.service.updateError" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    driverApi.updateDriverRide({ ...data }).then(onSuccess, onFailure);
  };

  // Formik Services

  const formikServices = useFormik({
    initialValues: {
      service:"",
      serviceType: "",
      vehicleNumber: "",
      vehicleModel: "",
      driverLicenseNumber: "",
      licenseExpiryDate: "",
      vehicleInsuranceNumber: "",
      insuranceExpiryDate: "",
      subcompanyname:"",
      vehicleColour:"",
      vehicleimage:"",
      allowedTypes: [],
    },
    validationSchema: yup.object({
      service: yup.string().required(t({ id: "driver.service.validate.serviceRequired" })).nullable(),
      serviceType: yup.string().required(t({ id: "driver.service.validate.serviceTypeRequired" })).nullable(),
      subcompanyname: yup
    .string()
    .nullable()
    .when("serviceType", {
      is: "ATTACHED_SERVICE",
      then: yup.string().required(t({ id: "driver.service.validate.subCompanyRequired" })),
      otherwise: yup.string().nullable(),
    }),
      allowedTypes: yup
      .array()
      .of(yup.string())
      .required(t({ id: "driver.service.validate.allowedTypesRequired" }))
      .min(1, t({ id: "driver.service.validate.atLeastOneType" }))
      .test(
        "includes-service",
        t({ id: "driver.service.validate.typeMustIncludeService" }),
        function (allowedTypes) {
          const serviceId = this.parent.service; // Get current service _id
          return allowedTypes.includes(serviceId);
        }
      ),
      vehicleNumber: yup
        .string()
        .required(t({ id: "driver.service.validate.vehicleNumberRequired" }))
        .nullable(),
      vehicleModel: yup
        .string()
        .required(t({ id: "driver.service.validate.vehicleModelRequired" }))
        .nullable(),
      driverLicenseNumber: yup
        .string()
        .required(t({ id: "driver.service.validate.licenseRequired" }))
        .nullable(),
      licenseExpiryDate: yup
        .string()
        .required(t({ id: "driver.service.validate.licenseExpiryRequired" }))
        .nullable(),
      insuranceExpiryDate: yup
        .string()
        .required(t({ id: "driver.service.validate.insuranceExpiryRequired" }))
        .nullable(),
      vehicleInsuranceNumber: yup
        .string()
        .required(t({ id: "driver.service.validate.insuranceNumberRequired" }))
        .nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handleUpdateServices(values); // Ensure this processes `values` correctly
    },
  });

  /**
   * Tabs 6
   * Status
   */

  // Handle Submit

  const basicInformationRef = useRef(null);
  const bankInformationRef = useRef(null);
  const vehicledocsRef = useRef(null);
  const servicesRef = useRef(null);
  const documentsRef = useRef(null);
  const statusRef = useRef(null);
  
  const handleCloseAndReset = () => {

    setValue(0); // Reset tab to 0

     // Call the resetPassengerImage method in BasicInformation
    if (basicInformationRef.current && basicInformationRef.current.resetPassengerImage) {
      basicInformationRef.current.resetPassengerImage();
    }
    formik.setErrors({});
    formik.setTouched({});
    formik.resetForm();
    
    formikServices.setErrors({});
    formikServices.setTouched({});
    formikServices.resetForm();
    handleClose(); // Close the modal
  };

  const handleCloseAllTabs = (data) => {
    if (data) {
      handleCloseAndReset();
    }
  };

  const handleSubmitAndNext = async () => {
    // Tab 1 Basic

    if (value === 0) {
      formik.handleSubmit();
    }

     // Tab 2 vehicle doc

    if (value === 1) {
      formikbank.handleSubmit();
    }
    // Tab 3 vehicle doc

    if (value === 2) {
      setValue(3)
    }

    // Tab 4 Service

    if (value === 3) {
      // handleClose();
      const servicesData = servicesRef.current();
      if (servicesData) {
        //console.log('servicesData--->',servicesData);
        formikServices.handleSubmit(servicesData);
      }
    }

   // Tab 5 status 
    if (value === 4) {
      const statusData = statusRef.current();
      if (statusData) {
        //console.log('statusData--->',statusData);
        handleOpenDriverModal();
      }
    }
  };

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              {t({ id: "driver.modal.update.title" })}
            </Typography>
            <IconButton aria-label="close" onClick={handleCloseAndReset}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          {/* Tabs */}
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label={t({ id: "driver.update.tabs.basic" })}  {...a11yProps(0)} />
                <Tab label={t({ id: "driver.update.tabs.bank" })}  {...a11yProps(1)} />
                <Tab label={t({ id: "driver.update.tabs.documents" })}  {...a11yProps(2)} />
                <Tab label={t({ id: "driver.update.tabs.services" })} {...a11yProps(3)} /> 
                {authUser?.userType !== "CORPORATE" && (
                  <Tab label={t({ id: "driver.update.tabs.status" })} {...a11yProps(4)} />
                )}
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0} >
              <BasicInformation
                onRef={(ref) => (basicInformationRef.current = ref)}
                driverId={driverId}
                formik={formik}
                setsubmitButton={setsubmitButton}
                setSkipButton={setSkipButton}
              />
            </CustomTabPanel>
              <CustomTabPanel value={value} index={1} >
              <BankInformation
                onRef={(ref) => (bankInformationRef.current = ref)}
                driverId={driverId}
                formikbank={formikbank}
                setsubmitButton={setsubmitButton}
                setSkipButton={setSkipButton}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2} >
              <Vehicledocuments
                onRef={(ref) => (vehicledocsRef.current = ref)}
                driverId={driverId}
                setsubmitButton={setsubmitButton}
                setSkipButton={setSkipButton}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3} >
              <Services
                onRef={(ref) => (servicesRef.current = ref)}
                formikServices={formikServices}
                driverId={driverId}
                setsubmitButton={setsubmitButton}
                setSkipButton={setSkipButton}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4} >
              <Status
                onRef={(ref) => (statusRef.current = ref)}
                driverId={driverId}
                setsubmitButton={setsubmitButton}
                setSkipButton={setSkipButton}
              />
            </CustomTabPanel>
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            {backButton && (
              <section className={classes.skipBtn}>
                <Button onClick={handleBackButton}>{t({ id: "driver.update.back" })}</Button>
              </section>
            )}
            {skipButton && (
              <section className={classes.skipBtn}>
                <Button onClick={handleSkipButton}>{t({ id: "driver.update.skip" })}</Button>
              </section>
            )}
            {submitButton && (
            <section className={classes.submBtn}>
              <Button onClick={handleSubmitAndNext}>{t({ id: "driver.update.submitNext" })}</Button>
            </section>
              )}
          </section>
        </DialogActions>
      </Dialog>
      <PreviewDriver
        openDialog={previewDriverModal}
        handleClose={handleClosePreviewDriverModal}
        driverId={driverId}
        setCloseAllTabs={handleCloseAllTabs}
      ></PreviewDriver>
    </>
  );
};

export default DriverUpdate;
